import {createSelector} from 'reselect';

const getMap = state => state.map;

export const selecetmaptype = createSelector([getMap], map => map);
